/** This is the default state */
const initialHelpState = {
  helpIsClicked: false,
}

export default function helpReducer(state = initialHelpState, action) {
  /** Remember that state is immutable - don't change/mutate
   * the incoming state, create a new state object and return that
   */
  switch (action.type) {
    case "HELP_ICON_CLICKED":
      return Object.assign({}, state, {
        helpIsClicked: true,
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/helpReducer.js